import React from 'react';
import DebugValue from 'components/Debug/DebugValue';

import 'components/Debug/DebugOverlay.scss';

const DebugItem: React.FC<{text: string, value?: string | any}> = ({text, value}) => {
  return <div className="debug-item">{text}{value && <DebugValue value={value} />}</div>;
};

export default DebugItem;